import type { ReactNode } from "react";
import { useContext, useMemo, useState } from "react";
import { AnimateModalContext } from "../context";

export const useHandleAnimateModalState = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [modalContent, setModalContent] = useState<ReactNode>(null);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    const value = useMemo(
        () => ({
            isOpen,
            modalContent,
            setModalContent,
            openModal,
            closeModal,
        }),
        [isOpen, modalContent],
    );

    return value;
};

export const useAnimateModal = () => {
    const context = useContext(AnimateModalContext);

    if (context === undefined) {
        throw new Error("애니메이트모달은 애니메이트모달 안에서만 유용합니다");
    }
    return context;
};
